import imageToBase64 from 'image-to-base64/browser';
import firebase from "firebase";
import {deleteFileByUrl} from "@/utils/upload-image";
import moment from "moment/moment";
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import VueGoodshareLinkedin from 'vue-goodshare/src/providers/LinkedIn.vue';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue';

export default {
  name: "GalleryShareDlg",
  components: {
    VueGoodshareFacebook,
    VueGoodshareLinkedin,
    VueGoodshareTwitter,
  },
  data() {
    return {
      addMediaDialog: false,
      photoSrc: "",
      currentPhoto: "",
      loading: false,
    }
  },
  props: {
    showOptions: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open(photo) {
      this.addMediaDialog = true;
      this.currentPhoto = photo;
      this.photoSrc = photo.image;
    },
    close() {
      this.loading = false;
      this.addMediaDialog = false;
    },
    async downloadPhoto(url) {
      try {
        const ImageUrl = url;
        const ImageBase64 = await imageToBase64(ImageUrl);
        const a = document.createElement('a');
        a.href = 'data:image/png;base64,' + ImageBase64;
        a.download = 'Photo.png';
        a.click();
      } catch (error) {
        console.error(error);
      }
    },
    async deletePhoto(photo) {
      this.loading = true;

      await firebase
        .firestore()
        .collection('photos')
        .doc(photo.id)
        .delete()
        .then(async () => {
          await deleteFileByUrl(photo.image)
            .then(async () => {
              const str = photo.image;
              const from = 0;
              const to = str.search('alt') - 1;
              const first = str.substring(from, to) + '_200x200';
              const second = str.substring(to, str.length);
              const url = first + second;
              await deleteFileByUrl(url);
            })
            .catch((error) => {
              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoCannotBeDeletedMessage'],
                type: 'error',
              });
            });
        })
        .catch(() => {
          this.$toast.open({
            message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoCannotBeDeletedMessage'],
            type: 'error',
          });
        });

      await this.$emit('getPhotos', photo)

      this.close();

      this.$toast.open({
        message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoSuccessfullyDeleted'],
        type: 'success',
      });
    },
    sharePhotoByEmail(photo) {
      this.close();
      this.$emit("sharePhotoByEmail", photo);
    },
  }
}